import { api, BULK_ENABLE_GAMES_MESSAGE, setConfig } from '../..';
import { mapEntityToApi } from './mapper';
import { mapToFormData, PropertyType } from '../../../common';

export const bulkEnableGames = (data: PropertyType): Promise<PropertyType> =>
	api.post('/games/bulk-enable-games', mapToFormData(mapEntityToApi(data)), setConfig(data)).then((res) => {
		return {
			message: BULK_ENABLE_GAMES_MESSAGE,
			nonImportedGames: res.data.notImportedGames,
			importedGames: res.data.importedGames,
			data: res.data,
		};
	});
